var map = {
	"./apple-laurel-da-DK.svg": 59123,
	"./apple-laurel-de-DE.svg": 55313,
	"./apple-laurel-en-GB.svg": 43195,
	"./apple-laurel-en-US.svg": 73556,
	"./apple-laurel-es-ES.svg": 82307,
	"./apple-laurel-es-MX.svg": 75568,
	"./apple-laurel-fr-FR.svg": 7175,
	"./apple-laurel-it-IT.svg": 15753,
	"./apple-laurel-nb-NO.svg": 25434,
	"./apple-laurel-nl-NL.svg": 87423,
	"./apple-laurel-pl-PL.svg": 75779,
	"./apple-laurel-pt-BR.svg": 67931,
	"./apple-laurel-pt-PT.svg": 47203,
	"./apple-laurel-sv-SE.svg": 8130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;